import { BROADCAST_SET_PRESENTER_ID } from 'actions/Types';

const initialState = '';

/**
 * @param {{}} state
 * @param {{
 * type : string
 * payload : string
 * }} action
 */
function presenterId(state = initialState, action) {
  const { type, payload } = action;

  if (type === BROADCAST_SET_PRESENTER_ID) {
    return payload;
  }

  return state;
}

export default presenterId;
